import { toValue } from 'vue'

export function useAddManualDiscount () {
  function addManualDiscount (orderItem, discount = null) {
    const orderItemValue = toValue(orderItem)
    const discountValue = toValue(discount)

    orderItemValue.manualDiscount = true
    orderItemValue.discountGroupKey = null
    orderItemValue.discountId = discountValue?.id
  }

  function addManualGroupDiscount (orderItemsToGroup, orderItemToDiscount, discount) {
    const orderItemsToGroupValue = toValue(orderItemsToGroup)
    const orderItemToDiscountValue = toValue(orderItemToDiscount)
    const discountValue = toValue(discount)

    const discountGroupKey = crypto.getRandomValues(new Uint32Array(1))[0]
    for (const orderItemValue of orderItemsToGroupValue) {
      orderItemValue.manualDiscount = true
      orderItemValue.discountGroupKey = discountGroupKey
      orderItemValue.discountId = null
    }

    orderItemToDiscountValue.manualDiscount = true
    orderItemToDiscountValue.discountGroupKey = discountGroupKey
    orderItemToDiscountValue.discountId = discountValue?.id
  }

  return {
    addManualDiscount,
    addManualGroupDiscount
  }
}
